import axios from 'axios';

let baseURL = process.env.REACT_APP_URL;

if (!baseURL) {
    baseURL = "https://master.bintix.com/api/v1/admin/"
    // baseURL = "http://127.0.0.1:8000/api/v1/admin/"
}

const instance = axios.create({
    baseURL,
    headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token'),
    },
});

instance.interceptors.response.use(
    response => response,
    error => {
        if (error.response && error.response.status === 401) {
            localStorage.clear();
            window.location.reload();
        }

        return Promise.reject(error);
    }
);

export default instance;